export const ATTRIBUTE_HUMAN_ID = 2;
export const ATTRIBUTE_ANIMAL_ID = 3;
export const ATTRIBUTE_OTHER_ID = 4;

export const HUMAN_GENDER_MALE_ID = 14;
export const HUMAN_GENDER_FEMALE_ID = 15;
